import { render, staticRenderFns } from "./ForemsProofwork.vue?vue&type=template&id=2d5f2f68&scoped=true"
import script from "./ForemsProofwork.vue?vue&type=script&lang=js"
export * from "./ForemsProofwork.vue?vue&type=script&lang=js"
import style0 from "./ForemsProofwork.vue?vue&type=style&index=0&id=2d5f2f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f2f68",
  null
  
)

export default component.exports